var FuseSearchBarModule = /** @class */ (function () {
    function FuseSearchBarModule() {
    }
    return FuseSearchBarModule;
}());
export { FuseSearchBarModule };
